export default {
  moneySymbol: 'ກິບ',
  tableForm: {
    search: 'ຄົ້ນຫາ',
    reset: 'ຄືນຄ່າໃໝ່',
    submit: 'ສົ່ງ',
    collapsed: 'ຂະຫຍາຍ',
    expand: 'ຫຍໍ້ລົງ',
    inputPlaceholder: 'ປ້ອນຂໍ້ມູນ',
    selectPlaceholder: 'ກະລຸນາເລືອກ',
  },
  alert: {
    clear: 'ຍົກເລີກການເລືອກ',
    selected: 'ເລືອກແລ້ວ',
    item: 'ລາຍການ',
  },
  pagination: {
    total: {
      range: ' ',
      total: 'ຈາກ',
      item: 'ບັນທຶກ',
    },
  },
  tableToolBar: {
    leftPin: 'ປັກຊ້າຍ',
    rightPin: 'ປັກຂວາ',
    noPin: 'ຍົກປັກ',
    leftFixedTitle: 'ຄົງທີ່ຊ້າຍ',
    rightFixedTitle: 'ຄົງທີ່ຂວາ',
    noFixedTitle: 'ຍັງບໍ່ຄົງທີ່',
    reset: 'ຄືນຄ່າໃໝ່',
    columnDisplay: 'ການສະແດງຖັນ',
    columnSetting: 'ການຕັ້ງຄ່າ',
    fullScreen: 'ໂໝດເຕັມຈໍ',
    exitFullScreen: 'ອອກຈາກໂໝດເຕັມຈໍ',
    reload: 'ຄືນຄ່າໃໝ່',
    density: 'ຄວາມໜາແໜ້ນການສະແດງ',
    densityDefault: 'ເລີ່ມຕົ້ນ',
    densityLarger: 'ໃຫຍ່',
    densityMiddle: 'ກາງ',
    densitySmall: 'ນ້ອຍ',
  },
};
